// extracted by mini-css-extract-plugin
export default {"submissionContainer":"uq9pC","single":"QWsO8","contentWrapper":"ewURh","submissionTitle":"V9JwO","processing":"x656S","accepted":"BoNDz","rejected":"PW75S","failed":"_9Uvvx"};